module.exports = __webpack_public_path__ + "img/con_item2_bgc.7a70776c.png";